// src/pages/Admin/Deposit.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Deposit() {
  const [funds, setFunds] = useState([]);
  const [processingFunds, setProcessingFunds] = useState({});

  // ✅ Fetch pending funds from localhost API
  const fetchFunds = async () => {
    try {
      const res = await axios.get("https://api.earnmoney0.top/admin/pending-funds");
      if (res.data.success) {
        setFunds(res.data.funds || []);
      }
    } catch (err) {
      console.error("❌ Fetch Pending Funds Error:", err);
    }
  };

  useEffect(() => {
    fetchFunds();
  }, []);

  const handleFundStatus = async (fundId, status) => {
    if (processingFunds[fundId]) return;

    try {
      setProcessingFunds((prev) => ({ ...prev, [fundId]: true }));

      const res = await axios.put(
        `https://api.earnmoney0.top/admin/fund-status/${fundId}`,
        { status }
      );

      if (res.data.success) {
        setFunds((prev) => prev.filter((f) => f._id !== fundId));

        const msg = document.createElement("div");
        msg.textContent = `Fund ${status} Successfully`;
        msg.style.position = "fixed";
        msg.style.top = "20px";
        msg.style.right = "20px";
        msg.style.background =
          status === "Approved"
            ? "linear-gradient(90deg, #00ff88, #00c46a)"
            : "linear-gradient(90deg, #ff5252, #d32f2f)";
        msg.style.color = "#fff";
        msg.style.fontWeight = "600";
        msg.style.padding = "10px 18px";
        msg.style.borderRadius = "8px";
        msg.style.boxShadow = "0 0 15px rgba(0,0,0,0.4)";
        msg.style.zIndex = "9999";
        document.body.appendChild(msg);
        setTimeout(() => msg.remove(), 2500);
      }
    } catch (err) {
      console.error("❌ Fund Status Update Error:", err);
      alert("⚠️ Failed to update fund status");
    } finally {
      setProcessingFunds((prev) => ({ ...prev, [fundId]: false }));
    }
  };

  return (
    <div style={{ padding: 20, color: "#fff", backgroundColor: "#0f172a", minHeight: "100vh" }}>
      <h2 style={{ fontSize: 24, marginBottom: 20, color: "#f2a900" }}>
  💰 Deposit Requests
</h2>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead style={{ backgroundColor: "#111827", color: "#f2a900" }}>
          <tr>
            <th style={{ padding: 8 }}>Username</th>
            <th style={{ padding: 8 }}>Phone</th>
            <th style={{ padding: 8 }}>Txn ID</th>
            <th style={{ padding: 8 }}>Method</th>
            <th style={{ padding: 8 }}>Amount</th>
            <th style={{ padding: 8 }}>Date</th>
            <th style={{ padding: 8 }}>Status</th>
            <th style={{ padding: 8 }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {funds.length === 0 ? (
            <tr>
              <td colSpan="8" style={{ textAlign: "center", padding: 12, color: "#ccc" }}>
                No pending deposit requests
              </td>
            </tr>
          ) : (
            funds.map((fund) => (
              <tr key={fund._id} style={{ borderBottom: "1px solid #222" }}>
                <td style={{ padding: 8 }}>
  {fund.userId?.username || fund.userId?.name || "N/A"}
</td>
                <td style={{ padding: 8 }}>{fund.userId?.phone || "N/A"}</td>
                <td style={{ padding: 8, color: "#00eaff", fontWeight: 600 }}>{fund.transactionId}</td>
                <td style={{ padding: 8 }}>{fund.method}</td>
                <td style={{ padding: 8, color: "#22c55e", fontWeight: 600 }}>৳{fund.amount}</td>
                <td style={{ padding: 8, color: "#ccc" }}>
                  {fund.createdAt ? new Date(fund.createdAt).toLocaleString() : "—"}
                </td>
                <td style={{ padding: 8 }}>
                  <span style={{ backgroundColor: "#facc15", color: "#000", padding: "2px 8px", borderRadius: 20, fontSize: 12, fontWeight: 600 }}>
                    {fund.status}
                  </span>
                </td>
                <td style={{ padding: 8, display: "flex", gap: 8, justifyContent: "center" }}>
                  <button
                    onClick={() => handleFundStatus(fund._id, "Approved")}
                    disabled={processingFunds[fund._id]}
                    style={{
                      backgroundColor: processingFunds[fund._id] ? "#555" : "#22c55e",
                      color: "#000",
                      padding: "4px 10px",
                      borderRadius: 6,
                      cursor: processingFunds[fund._id] ? "not-allowed" : "pointer",
                    }}
                  >
                    ✅ Approve
                  </button>
                  <button
                    onClick={() => handleFundStatus(fund._id, "Rejected")}
                    style={{
                      backgroundColor: "#ef4444",
                      color: "#fff",
                      padding: "4px 10px",
                      borderRadius: 6,
                    }}
                  >
                    ❌ Cancel
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}